import axios from 'axios'

// Get dashboard data for a workspace ('personal' or an org slug)
const getDashboard = async (token, workspace = 'personal') => {
    const config = { headers: { Authorization: `Bearer ${token}` } }
    const url = workspace && workspace !== 'personal'
        ? `/api/orgs/${workspace}/dashboard`
        : '/api/dashboard/'
    const response = await axios.get(url, config)
    return response.data
}

const dashboardService = {
    getDashboard,
}

export default dashboardService
